import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '../../shared/index';
import { FormElementListing } from '../shared/model/listing/form-element-listing.model';
import { RevenueItemService } from '../../revenue/shared/revenue-items/revenue-item.service';
import { RevenueItem } from '../../revenue/shared/revenue-items/revenue-item.model';

@Component({
  selector: 'wl-form-builder-listing-edit-element',
  templateUrl: 'form-builder-listing-edit-element.component.html',
    standalone: false
})
export class FormBuilderListingEditElementComponent {
  private _translationService: TranslationService;
  private _revenueItemService: RevenueItemService;

  public listingSettings: FormElementListing;
  public revenueItems: Array<RevenueItem>;

  public constructor(translationService: TranslationService, revenueItemService: RevenueItemService) {
    this._translationService = translationService;
    this._revenueItemService = revenueItemService;
    this.revenueItems = [];
  }

  ngOnInit(): void {
    this.listingSettings = new FormElementListing();
    this._revenueItemService.getRevenueItems().then((data: Array<RevenueItem>) => {
      this.revenueItems = data;
    });
  }
}
